<template>
  <div>
    <div class="flex justify-between">
      <div class="left flex">
        <router-link to="/branches">
          <img
            class="resto-logo"
            src="@assets/images/pathao-logo.svg"
            alt="Logo"
          />
        </router-link>
      </div>
      <div class="right flex items-center">
        <pt-dropdown ref="dropdown">
          <div
            slot="button"
            @click="toggleDropdown"
          >
            <div class="flex items-center sm:ml-2">
              <img
                :src="userAvatar"
                class="w-10 h-10 rounded-full mr-4"
                alt="avatar"
              />
              <div class="user hidden lg:block">
                <p class="user-name">{{ auth.user.name }} <i class="fa fa-caret-down" /></p>
              </div>
            </div>
          </div>
          <a
            role="menuitem"
            class="pt-dropdown-item cursor-pointer"
            @click="toResetPassword"
          > Reset Password</a>
          <a
            role="menuitem"
            class="pt-dropdown-item cursor-pointer"
            @click="handleLogout"
          > Logout</a>
        </pt-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Logo from './Logo';
import config from '../../config';
import { PtDropdown, PtDropdownItem } from '@pathao/ui-components/esm/Dropdown';

export default {
  name: 'TopBar',
  components: {
    Logo,
    PtDropdown,
    PtDropdownItem,
  },
  data() {
    return {
      imageURL: '',
      notifications: [],
      newNotificationCounter: 0,
    };
  },
  computed: {
    ...mapState(['auth']),
    ...mapGetters({
      userName: 'auth/userName',
    }),
    userAvatar() {
      if (this.auth.user.profile_pic) {
        return config.api.imageURL + this.auth.user.profile_pic;
      }
      return '/img/default-user.3c1dd009.png';
    },
  },
  methods: {
    toResetPassword() {
      this.$router.replace({ name: 'reset-pass' });
    },
    toggleSideBar() {
      this.$bus.$emit('toggle-sidebar');
    },
    toggleDropdown() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.toggle();
      }
    },
    toggleNotiDropdown() {
      if (this.$refs.notiDropdown) {
        this.$refs.notiDropdown.toggle();
      }
    },
    handleLogout() {
      this.$sendEvent('RS_Logout');
      this.logOut().then(() => {
        this.$router.push({ name: 'login' });
      });
    },
    ...mapActions({
      logOut: 'auth/logOut',
    }),
  },
};

</script>

<style>
  .user .user-name {
    font-size: 17px;
    color: #000000;
  }

  .user .user-meta {
    opacity: 0.4;
    font-size: 13px;
    color: #000000;
    width: 140px;
  }

  .pt-dropdown {
    cursor: pointer;
  }

  .pt-dropdown-item.noti {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #DDD;
  }

  /*.pt-dropdown-item.noti .see-all {
    margin-top: 15px;
  }*/
  .pt-dropdown-item {
    font-size: 14px;
    color: #152934;
    text-align: left;
    font-weight: normal;
    padding-bottom: .7rem;
    padding-top: .7rem;
  }

  .pt-dropdown-item i.fa {
    padding-right: 10px
  }

  .pt-dropdown-item:hover {
    background: #F5F6F7;
    font-size: 14px;
    color: #152934;
    text-align: left;
    line-height: 20px;
    font-weight: 600;
    cursor: pointer;
  }
</style>
